import {http} from './config';
export default{
  
    setVisita:(usuario)=>{
        return http.post('api/set_visita',usuario);
    },
    getVisita:()=>{
        return http.get('api/get_visita');
    },
    getVisitasMap:()=>{
        return http.get('api/get_visitas_map');
    }

}